/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import CocosAnimationEffect from '../../../Library/Scripts/Effects/CocosAnimationEffect';
import GameSetup from '../../../Library/Scripts/Game/GameSetup';
import InjectableComponent from '../../../Library/Scripts/Utility/Component/ComponentReference/InjectableComponent';
import ComponentBase from '../../../Library/Scripts/Utility/ComponentBase';

const ccclass = cc._decorator.ccclass;
const property = cc._decorator.property;

@ccclass
export default class RGSPlaybarAnimSelector extends ComponentBase
{
    @property(CocosAnimationEffect)
    public effect: CocosAnimationEffect = null;

    @property(cc.AnimationClip)
    public clip3: cc.AnimationClip = null;

    @property(cc.AnimationClip)
    public clip4: cc.AnimationClip = null;

    @property(cc.AnimationClip)
    public clip5: cc.AnimationClip = null;

    private _gameSetupRef: InjectableComponent<GameSetup> = new InjectableComponent();

    protected setContexts(): void
    {
        super.setContexts();
        this._gameSetupRef.SetContext(GameSetup);
    }

    protected start(): void
    {
        super.start();

        this._gameSetupRef.Value.OnSetupReceived((): void =>
        {
            switch (this._gameSetupRef.Value.AutoSpinOptions.length)
            {
                case 1:
                case 2:
                    this.effect.AnimationName = this.clip3.name;
                    break;
                case 3:
                    this.effect.AnimationName = this.clip4.name;
                    break;
                default:
                    this.effect.AnimationName = this.clip5.name;
            }
        });
    }
}
